export type WorkbenchRouteName =
  | 'wb-batch'
  | 'wb-tools'
  | 'wb-tasks'
  | 'wb-recharge'
  | 'wb-contact'
  | 'wb-account'

import type { WorkbenchToolId } from './workbenchTools'
import { workbenchToolsMeta } from './workbenchTools'
import { workbenchPath } from './workbenchPaths'

export type WorkbenchNavItem = {
  name: WorkbenchRouteName
  label: string
  to: string
  icon?: string
}

export const workbenchNavPrimary: WorkbenchNavItem[] = [
  { name: 'wb-batch', label: '批处理工作台', to: workbenchPath('/batch'), icon: 'layers' },
  { name: 'wb-tools', label: 'AI智能工具', to: workbenchPath('/tools'), icon: 'psychology' },
  { name: 'wb-tasks', label: '任务列表', to: workbenchPath('/tasks'), icon: 'format_list_bulleted' },
]

export const workbenchNavSecondary: WorkbenchNavItem[] = [
  { name: 'wb-recharge', label: '充值与消耗', to: workbenchPath('/recharge'), icon: 'account_balance_wallet' },
  { name: 'wb-contact', label: '联系我们', to: workbenchPath('/contact'), icon: 'support_agent' },
]

export function getWorkbenchNavLabel(name: unknown) {
  const n = String(name || '')
  for (const it of [...workbenchNavPrimary, ...workbenchNavSecondary]) {
    if (it.name === n) return it.label
  }
  if (n === 'wb-account') return '账号管理'
  if (n === 'wb-subaccounts') return '账号管理'
  return ''
}

export function getWorkbenchToolLabel(id: unknown) {
  const x = String(id || '').trim()
  return workbenchToolsMeta.find((t) => t.id === (x as WorkbenchToolId))?.title || ''
}
